export const MESSAGE_TYPE = {
  INIT_CHANNEL: 'initChannel',
  SIGN_MESSAGE: 'signMessage',
  PING: 'ping',
} as const;

export type MessageType = (typeof MESSAGE_TYPE)[keyof typeof MESSAGE_TYPE];

export const SEND_MESSAGE_TYPE = {
  WALLET_READY: 'walletReady',
  CONNECTED: 'connected',
  ON_LOAD: 'onLoad',
} as const;

export type SendMessageType =
  (typeof SEND_MESSAGE_TYPE)[keyof typeof SEND_MESSAGE_TYPE];
